import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Switch,
  Button,
  TextField,
  Dialog,
  Tabs,
  Tab,
  DialogContent,
  Backdrop,
  makeStyles,
  IconButton,
  Slide,
  Box,
} from "@material-ui/core";
import ViewPermissions from "./ViewPermissions";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../containers/actions/types";
import ViewTeamMembers from "./ViewTeamMembers";
import { useDispatch, useSelector } from "react-redux";

// const calculateDaysAgo = (date) => {
//   const today = new Date();
//   const givenDate = new Date(date);
//   const differenceInMilliseconds = today - givenDate;
//   const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

//   if (differenceInDays === 0) {
//     const differenceInHours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
//     if (differenceInHours === 0) {
//       return "Now";
//     }
//     return "Today";
//   }
//   return `${differenceInDays} days ago`;
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  header: {
    backgroundColor: "#F9F9FC",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  addButton: {
    border: "1px solid black",
    borderRadius: "25px",
    color: "black",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "Black",
      color: "white",
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    //color: '#fff',
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  inline: {
    fontSize: "1.35rem",
    display: "inline",
    fontWeight: 550,
    marginBottom: "0.5rem",
  },
  heading: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1.5rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "1px solid grey",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },
    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  requiredStar: {
    color: "red",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    overflow: "hidden",
    pointerEvents: "none",
    touchAction: "none",
    userSelect: "none",
    resize: "none",
  },
  "@keyframes slideIn": {
    from: {
      transform: "translateX(100%)",
    },
    to: {
      transform: "translateX(0)",
    },
  },
}));

// const hardcodedData = {
//   roleName: "Distribution Manager",
//   roleDescription:
//     "Full access to all functions of the platform for setup, configuration, billing, payments, maintenance, user and project management.",
//   createdBy: "John Doe",
//   creationDate: "2024-01-15",
//   roleType: "DefaultType",
//   lastUpdatedBy: "Jane Smith",
//   lastUpdatedDate: new Date().toISOString(),
//   departmentName:"External-Manufacturing" // Simulates "updated today" scenario
// };

const ViewRolesAndAccess = ({ openDialog, closeViewScreen, selectedRole }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [view, setView] = useState("RoleDetails"); // Current tab view

  const [optionsAndPermissions, setOptionsAndPermissions] = useState({
    stepAuthenticated: true,
    editPhoneNumber: true,
    azureAdSignIn: true,
  });

  const teamMembersList = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetails;
  });

  const teamMembersListLoading = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetailsLoading || {};
  });

  useEffect(() => {
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        departmentID: selectedRole.departmentID,
        collaborator_role_id: selectedRole.collaborator_role_id,
        //   departmentID: 0,
        //   collaborator_role_id: 0,
        searchString: "all",
        status: "Active",
        // pageNumber: currentPage,
        // pageSize: rowsPerPage,
      })
    );
  }, []);

  const handleTabChange = (event, newValue) => {
    setView(newValue);
  };

  const handleChangeOptionsAndPermissions = (event) => {
    setOptionsAndPermissions({
      ...optionsAndPermissions,
      [event.target.name]: event.target.checked,
    });
  };

  // Role Details Tab
  const renderRoleDetails = () => (
    <Grid container spacing={3} style={{ marginTop: 16 }}>
      {/* Description */}
      <Grid
        style={{
          border: "2px solid #E0E0E0",
          borderRadius: "0.5rem",
          padding: "2rem",
          marginBottom: "1rem",
        }}
        item
        xs={12}
      >
        <Typography variant="subtitle1" style={{ fontWeight: "600" }}>
          Description
        </Typography>
        <Typography
          variant="body2"
          style={{ color: "#808080", marginBottom: "1rem" }}
        >
          Should be clear for anyone using this role, so that they can allow
          correct people to join as team members in the platform.
        </Typography>
        <Typography variant="body2">
          {selectedRole?.role_description
            ? selectedRole?.role_description
            : "NA"}
        </Typography>
      </Grid>

      {/* Options and Permissions */}
      <Grid item xs={12}>
        <Grid
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          container
          spacing={2}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                2-Step Authenticated
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Authenticate the person using a code sent to their device.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                disabled={optionsAndPermissions.stepAuthenticated}
                checked={optionsAndPermissions.stepAuthenticated}
                onChange={handleChangeOptionsAndPermissions}
                name="stepAuthenticated"
              />
            </Grid>
          </Grid>
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                Edit Phone Number
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Don’t allow the user to edit their phone number.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                checked={optionsAndPermissions.editPhoneNumber}
                onChange={handleChangeOptionsAndPermissions}
                disabled={optionsAndPermissions.editPhoneNumber} // Disable if true
                name="editPhoneNumber"
              />
            </Grid>
          </Grid>

          {localStorage.getItem('collabType') !== 'CMO' && <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                Ping Sign-In Enabled
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Enable this option to use Ping credentials.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                checked={optionsAndPermissions.azureAdSignIn}
                onChange={handleChangeOptionsAndPermissions}
                disabled={optionsAndPermissions.azureAdSignIn}
                name="azureAdSignIn"
              />
            </Grid>
          </Grid>}
        </Grid>
      </Grid>
    </Grid>
  );

  // Permissions Tab
  // const renderPermissions = () => (
  //   <Typography style={{ marginTop: 16 }}>Permissions content here...</Typography>
  // );

  // Team Members Tab

  return (
    <>
      <Dialog open={openDialog} fullScreen>
        <Grid
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
          container
          direction="column"
        >
          <Typography variant="h5" style={{
            fontWeight: "bold"
          }} >
            View Role
          </Typography>
          {/* Header Section */}
          <Grid
            container
            // alignItems="center"
            // justifyContent="space-between"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1rem"
            }}
          >
            <Button
              startIcon={<ArrowBackIosIcon />}
              onClick={closeViewScreen}
              style={{ textTransform: "none", fontWeight: "550" }}
            >
              Back
            </Button>
          </Grid>

          <Grid container alignItems="center">
            <Typography
              variant="h5"
              style={{ fontWeight: "600" }}
              display="inline"
            >
              {selectedRole?.departmentName
                ? selectedRole?.departmentName
                : "NA"}{" "}
            </Typography>
            <Typography style={{ fontWeight: "bold", padding: "0 4px" }} display="inline">
              -
            </Typography>
            <Typography
              variant="h5"
              display="inline"
              style={{
                cursor: "pointer",
                fontWeight: "600",
                // textDecoration: roleName !== initialRoleName ? 'underline' : 'none',
              }}
            >
              {selectedRole?.role_name ? selectedRole?.role_name : "NA"}
            </Typography>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: "2rem",
            }}
          >
            <Typography variant="body2" color="black">
              {selectedRole?.roleType ? selectedRole?.roleType : "NA"}
            </Typography>
          </Grid>
        </Grid>

        <DialogContent
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
        >
          <Tabs
            value={view}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab
              style={{ color: view === "RoleDetails" ? "#1890ff" : "black" }}
              label="Role Details"
              value="RoleDetails"
            />
            <Tab
              style={{ color: view === "Permissions" ? "#1890ff" : "black" }}
              label="Permissions"
              value="Permissions"
            />
            <Tab
              style={{ color: view === "TeamMembers" ? "#1890ff" : "black" }}
              // label="Team Members"
              label={`Team Members (${selectedRole?.userCount || 0})`}
              value="TeamMembers"
            />
          </Tabs>
          <Grid item xs={12}>
            {view === "RoleDetails" && renderRoleDetails()}
            {view === "Permissions" && (
              <ViewPermissions selectedRole={selectedRole} />
            )}
            {view === "TeamMembers" && (
              <ViewTeamMembers
                teamMembersListLoading={teamMembersListLoading}
                teamMembersList={teamMembersList}
                selectedRole={selectedRole}
              />
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewRolesAndAccess;
